import { render, staticRenderFns } from "./FormPersonaV2.vue?vue&type=template&id=2850789f&scoped=true"
import script from "./FormPersonaV2.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPersonaV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormPersonaV2.vue?vue&type=style&index=0&id=2850789f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850789f",
  null
  
)

export default component.exports